import React from 'react';

import {Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {AfriexBankAccount, AfriexPaymentMethod} from '@/types';

interface VirtualBankAccountsProps {
  accounts: AfriexPaymentMethod[];
}

const VirtualBankAccounts: React.FC<VirtualBankAccountsProps> = ({
  accounts,
}) => {
  if (!accounts || accounts.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 px-3 pt-3">
      <h3 className="font-semibold uppercase text-gray-900 dark:text-gray-300 mb-4">
        Virtual Bank Accounts
      </h3>
      <Table>
        <Thead>
          <Tr>
            <Th className="pl-6">Bank Name</Th>
            <Th>Account Number</Th>
            <Th>Account Name</Th>
            <Th>Currency</Th>
          </Tr>
        </Thead>
        <TBody>
          {accounts.map((account) => {
            const info = account.info as AfriexBankAccount;
            return (
              <Tr key={account.id}>
                <Td className="pl-6 font-semibold">{info?.bankName || '-'}</Td>
                <Td>{info?.accountNumber || '-'}</Td>
                <Td>
                  <span
                    className="truncate max-w-[200px] inline-block align-bottom"
                    title={info?.accountName}
                  >
                    {info?.accountName || '-'}
                  </span>
                </Td>
                <Td>{info?.currency || '-'}</Td>
              </Tr>
            );
          })}
        </TBody>
      </Table>
    </div>
  );
};

export default VirtualBankAccounts;
